/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpLogger from 'mbp-logger';

import States from '../../../../constants/states';
import { defaultCountryList } from '../../../../constants/country';
import { convertThreeDigitCountryCode } from '../../../../../../../state/ducks/Checkout/ducks/Checkout/Checkout-Helper';
import orderClient from '../../../../../../../apis/checkout-apis/orderClient';
import { getAccessTokenSafely } from '../../../../../../../state/ducks/Member/ducks/Auth/Plugin/auth/auth';
import { getCountryCodeFromTwoToThreeDigit, getCountryDetailsByThreeDigitCountryCode } from '../../../../../../../state/ducks/Checkout/helpers/countryCode';
import { getFormattedDate } from './Helper';
import getPriceFromEngine from '../../../../../../../apis/product-apis/priceEngine';

export const inputProperties = {
    Residence: {
        message: 'Please remember to include an apartment or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'Recipient\'s First and Last Name',
            firstName: 'Recipient\'s First Name',
            lastName: 'Recipient\'s Last Name',
            locationType: 'Location Type',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
    Business: {
        message: 'Please remember to include a suite or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Company Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at work, we\'ll call them to make sure we can deliver their gift.',
    },
    'Funeral home': {
        message: 'If you need special assistance regarding you funeral order, please contact one of our Special Sympathy Advisors at (866)-538-2259',
        formFieldLabels: {
            firstAndLastName: 'Deceased First and Last Name',
            firstName: 'Deceased First Name',
            lastName: 'Deceased Last Name',
            locationType: 'Location Type',
            organizationName: 'Funeral Home Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Funeral Home Telephone',
        },
        toolTipText: '"If there\'s a delivery issue, ie. the service started earlier or later , we\'ll call them to make sure we can deliver the arrangement.',
    },
    Hospital: {
        message: 'Patients in emergency rooms or ICU/CCU units may not be able to receive deliveries.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Hospital Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the patient was moved to different unit, we\'ll call them to make sure we can deliver their gift',
    },
    School: {
        message: 'Due to many school\'s security regulations, delivery to schools may not be guaranteed.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'School Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at school, we\'ll call them to make sure we can deliver their gift',
    },
    Church: {
        message: 'If you need special assistance regarding a memorial service, please contact one of our Special Sympathy Advisors at (866)-538-2259.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Church Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
    Apartment: {
        message: 'Please remember to include an apartment or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
};

export const inputPropertiesFood = {
    Residence: {
        message: 'Please remember to include an apartment or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'Recipient\'s First and Last Name',
            firstName: 'Recipient\'s First Name',
            lastName: 'Recipient\'s Last Name',
            locationType: 'Location Type',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
    Business: {
        message: 'Please remember to include a suite or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Company Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at work, we\'ll call them to make sure we can deliver their gift.',
    },
    POBox: {
        formFieldLabels: {
            firstAndLastName: 'Recipient\'s First and Last Name',
            firstName: 'Recipient\'s First Name',
            lastName: 'Recipient\'s Last Name',
            locationType: 'Location Type',
            address1: 'P.O. Box',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
    },
    APOFPO: {
        formFieldLabels: {
            firstAndLastName: 'Recipient\'s First and Last Name',
            firstName: 'Recipient\'s First Name',
            lastName: 'Recipient\'s Last Name',
            locationType: 'Location Type',
            address1: 'Unit/Ship/PSC Number',
            address2: 'Box/Hull Number',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'APO/FPO Address Help.When ordering, choose APO/FPO MILITARY and select from the Armed Forces delivery locations within the State drop down menu field. Please allow at least 5 weeks transit time for delivery.',
    },
};

export const inputPropertiesPersonalization = {
    ...inputProperties,
    POBox: inputPropertiesFood.POBox,
    APOFPO: inputPropertiesFood.APOFPO,
};

export const inputPropertiesStandalone = {
    Residence: {
        message: 'Please remember to include an apartment or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'Recipient\'s First and Last Name',
            firstName: 'Recipient\'s First Name',
            lastName: 'Recipient\'s Last Name',
            locationType: 'Location Type',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            country: 'Country',
            zipCode: 'Zip Code',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at home, we\'ll call them to make sure we can deliver their gift.',
    },
    Business: {
        message: 'Please remember to include a suite or unit number in "Address Line 2" if available.',
        formFieldLabels: {
            firstAndLastName: 'First and Last Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            locationType: 'Location Type',
            organizationName: 'Company Name',
            address1: 'Delivery Address',
            address2: 'Apt/Suite/Room',
            city: 'City',
            state: 'State',
            zipCode: 'Zip Code',
            country: 'Country',
            phone: 'Recipient Phone Number',
        },
        toolTipText: 'If there\'s a delivery issue, ie. the recipient is not at work, we\'ll call them to make sure we can deliver their gift.',
    },
};

export const inputStates = {
    locationType: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    savedAddress: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    firstName: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    lastName: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    relationship: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    organizationName: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    address1: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    address2: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    city: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    state: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    zipCode: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    country: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    phone: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    email: {
        required: true,
        flagError: false,
        errorMessage: '',
    },
    occasionId: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    occasionMonth: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    occasionDay: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    occasionYear: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    extraOccasionMonth: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    extraOccasionDay: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
    extraOccasionYear: {
        required: false,
        flagError: false,
        errorMessage: '',
    },
};

export const occasionsList = {
    data: [
        {
            code: '7',
            name: 'Anniversary',
            type: 'Event',
            remindMe: true,
        },
        {
            code: 'BOSS',
            name: 'Boss\' Day',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: '3',
            name: 'Birthday',
            type: 'Event',
            remindMe: true,
        },
        {
            code: 'XMAS',
            name: 'Christmas',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'CINCO',
            name: 'Cinco de Mayo',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'DIWALI',
            name: 'Diwali',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'EAST',
            name: 'Easter',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'EID',
            name: 'Eid',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'FATH',
            name: 'Father\'s Day',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'FRIENDSHIP',
            name: 'Friendship Day',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'HALLOWEEN',
            name: 'Halloween',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'HANNUKAH',
            name: 'Hannukah',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: '12',
            name: 'Just Because',
            type: 'Event',
            remindMe: true,
        },
        {
            code: 'MEMORIAL',
            name: 'Memorial Day',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'MDAY',
            name: 'Mother\'s Day',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'NEWYEAR',
            name: 'New Year\'s',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'PARENT',
            name: 'Parents\' Day',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'THAN',
            name: 'Thanksgiving',
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'VDAY',
            name: "Valentine's Day",
            type: 'Holiday',
            remindMe: true,
        },
        {
            code: 'VETERAN',
            name: 'Veteran\'s Day',
            type: 'Holiday',
            remindMe: true,
        },
        // {
        //     code: '19',
        //     name: 'Wedding',
        //     type: 'Event',
        //     remindMe: true,
        // },
    ],
    loading: false,
};

export const countriesProps = {
    US: {
        state: {
            label: 'State',
            dropdownData: States.US,
        },
        zipCode: {
            label: 'Zip Code',
            max: 10,
            min: 5,
            inputType: 'AlphaNumericSpecial',
            inputFieldType: 'tel', // set input type="tel" for numberic keyboard to appear mobile (tel type is needed for iphone)
        },
    },
    USA: {
        state: {
            label: 'State',
            dropdownData: States.US,
        },
        zipCode: {
            label: 'Zip Code',
            max: 10,
            min: 5,
            inputType: 'AlphaNumericSpecial',
            inputFieldType: 'tel', // set input type="tel" for numberic keyboard to appear mobile (tel type is needed for iphone)
        },
    },
    CA: {
        state: {
            label: 'Province',
            dropdownData: States.CA,
        },
        zipCode: {
            label: 'Postal Code',
            min: 6,
            max: 7,
            inputType: 'AlphaNumericSpecial',
            inputFieldType: 'text',
        },
    },
    CAN: {
        state: {
            label: 'Province',
            dropdownData: States.CA,
        },
        zipCode: {
            label: 'Postal Code',
            min: 6,
            max: 7,
            inputType: 'AlphaNumericSpecial',
            inputFieldType: 'text',
        },
    },
};

export const getInputProperties = (type) => {
    if (type === 'food') {
        return inputPropertiesFood;
    }
    if (type === 'personalization') {
        return inputPropertiesPersonalization;
    }
    if (type === 'standalone') {
        return inputPropertiesStandalone;
    }

    return inputProperties;
};

export const sanitizeLocationType = (locationType, presentationFamily, organizationName, isDigitalProduct) => {
    const locationTypes = Object.keys(getInputProperties(presentationFamily));
    if (Array.isArray(locationTypes) && !locationTypes.includes(locationType)) {
        if (organizationName) {
            return 'Business';
        }

        if (locationType === 'APO/FPO') {
            return 'APOFPO';
        }

        return 'Residence';
    }
    if (locationType === 'Residence' && organizationName) {
        return 'Business';
    }

    if (isDigitalProduct && locationType !== 'Residence') {
        return 'Residence';
    }

    return locationType;
};

export const getListLocationTypes = (presentationFamily) => {
    const locationTypes = Object.keys(getInputProperties(presentationFamily));

    const locationTypeArray = locationTypes.map((location) => {
        let valueDisplay = null;

        if (location === 'POBox') {
            valueDisplay = 'P.O. Box';
        } else if (location === 'APOFPO') {
            valueDisplay = 'APO/FPO';
        }

        return ({
            key: location,
            value: valueDisplay || location,
        });
    });

    return locationTypeArray;
};

export const getListStates = (country) => {
    if (States[country]) {
        const states = {
            '': '',
            ...States[country],
        };

        return Object.keys(states).map((state) => ({
            key: state,
            value: states[state],
        }));
    }
    return [];
};

export const getListCountries = (deliverableCountry) => {
    let countryList = defaultCountryList || [];

    if (deliverableCountry?.length > 0) {
        countryList = convertThreeDigitCountryCode(deliverableCountry) || [];
    }

    return countryList.map((country) => ({
        key: country.key,
        value: country.value,
    }));
};

export const getListCity = (cityArray) => {
    const cityMapped = [];
    if (cityArray.length > 0) {
        cityArray.forEach((city) => (
            cityMapped.push({
                key: city.toLowerCase().replace(/(?:^|\s)\S/g, (a) => a.toUpperCase()),
                value: city.toLowerCase().replace(/(?:^|\s)\S/g, (a) => a.toUpperCase()),
            })
        ));
    }
    cityMapped.push({
        key: 'CNS',
        value: 'City Not Shown',
    });
    return cityMapped;
};

export const isInternationalProduct = (currentRecipient = []) => {
    const [cartItems] = currentRecipient?.[0]?.cartItems || {};
    const isInternational = ['USA', 'US', 'CAN', 'CA'].includes(cartItems?.deliveryInfo?.countryCode || '');
    if (isInternational) {
        return true;
    }
    return false;
};

export const useQasAddressSearch = (flags, hasQasFailed) => {
    if (flags['is-qas-address-suggestions-enabled'] && !hasQasFailed) {
        return true;
    }
    return false;
};

export const useGoogleAddressSearch = (flags, hasQasFailed, formFieldLabels) => {
    if (
        flags['is-google-places-enabled']
        || (
            flags['is-qas-address-suggestions-enabled']
            && hasQasFailed
            && ['US', 'CA', 'USA', 'CAN'].includes(formFieldLabels.country)
        )
    ) {
        return true;
    }
    return false;
};

export const getFlagError = (localFieldState, serverFieldState) => {
    if (localFieldState.flagError || serverFieldState) {
        return true;
    }
    return false;
};

export const getErrorMessageFullName = (error, formFieldLabelstate) => {
    let firstAndLastNameErrorMessage = error.firstAndLastName || error.firstName || error.lastName || formFieldLabelstate.firstAndLastName.errorMessage;
    if (firstAndLastNameErrorMessage === 'Last Name can not be empty.') {
        firstAndLastNameErrorMessage = 'Recipient\'s last name is required';
    }
    return firstAndLastNameErrorMessage;
};

export const isCandaZip = (zipcode) => new RegExp(/^[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[- ]{0,1}[0-9]{1}[a-zA-Z]{1}[0-9]{1}/).test(zipcode);

const capitalizeCity = (city) => city?.toLowerCase().replace(/(?:^|\s)\S/g, (a) => a.toUpperCase());

const getCity = (cityList, selectCity) => {
    if (selectCity && cityList?.find((city) => city.toLowerCase() === selectCity.toLowerCase())) {
        return capitalizeCity(cityList.find((city) => city.toLowerCase() === selectCity.toLowerCase()) || '');
    }
    return capitalizeCity(cityList?.[0] || selectCity || '');
};

const getFormattedZipCode = (zipCode) => {
    let zipCodeFormatted = zipCode;
    if (zipCodeFormatted && (zipCodeFormatted.length === 6 || zipCodeFormatted.length === 7) && isCandaZip(zipCodeFormatted)) {
        const zipSplit = zipCodeFormatted.replace(/\s/gi, '').toUpperCase().split('');
        zipSplit.splice(3, 0, ' ');
        zipCodeFormatted = zipSplit.join('');
    }
    return zipCodeFormatted;
};

const removeMaskForPhoneNumber = (number) => {
    let strNumber = number?.toString().trim() || '';
    strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9+]/g, '');
    if (strNumber.indexOf('+') === 0 && strNumber.indexOf('1') === 1) {
        strNumber = strNumber.substring(2, strNumber.length);
    } else if (strNumber.indexOf('+') >= 0) {
        strNumber = strNumber.replace(/\s/g, '').replace(/[^0-9]/g, '');
    }
    return strNumber;
};

const getDigitalAddressData = (formFieldValues, recipientAddress) => {
    // the first choice for the background adddress autofill is another jaddress the user entered
    // however, sometimes the movie item is the first item the user fills out recipient info for
    // in this case the 18F headquarters is used by default
    const previousAddress = recipientAddress;

    if (previousAddress.firstName) { // if the movie item is not first
        return {
            ...formFieldValues,
            locationType: 'Residence',
            address1: previousAddress.address1,
            address2: previousAddress.address2,
            city: previousAddress.city,
            state: previousAddress.state,
            country: previousAddress.country,
            zipCode: previousAddress.zipCode,
            phone: previousAddress.phoneNumber,
            isAddressVerified: 'Y',
            dpvIndicator: 'Y',
            isFormValid: true,
        };
    }
    return {
        ...formFieldValues,
        locationType: 'Residence',
        address1: '1 Old Country Rd',
        address2: 'STE 500',
        city: 'Carle Place',
        state: 'NY',
        country: 'US',
        zipCode: '11514',
        phone: '5162376000',
        isAddressVerified: 'Y',
        dpvIndicator: 'Y',
        isFormValid: true,
    };
};

export const getFormattedRecipientData = (formFieldValues, isDigitalProduct, recipientAddress = {}) => {
    let recipientData = { ...formFieldValues };
    if (isDigitalProduct) {
        recipientData = getDigitalAddressData(formFieldValues, recipientAddress);
    }
    let locationType = recipientData.locationType?.trim();
    if (locationType === 'POBox') {
        locationType = 'P.O.Box';
    } else if (locationType === 'APOFPO') {
        locationType = 'APO/FPO';
    }
    let organizationName = recipientData.organizationName?.trim();
    if (['POBox', 'APOFPO', 'Residence'].includes(recipientData.locationType)) {
        organizationName = '';
    }

    let state = recipientData.state?.trim();
    if (!['US', 'CA', 'USA', 'CAN'].includes(recipientData.country)) {
        state = 'OS';
    }
    let country = recipientData.country?.trim() || 'USA';
    if (country.length === 2) {
        country = getCountryCodeFromTwoToThreeDigit(recipientData.country?.trim());
    }

    const phone = recipientData.phone || recipientData.phoneNumber || '';

    const addressData = {
        addressId: recipientData?.entryId || '',
        addressBookRecipientId: recipientData?.rcpId || recipientData?.addressBookRecipientId || '',
        firstName: recipientData.firstName?.trim(),
        lastName: recipientData.lastName?.trim(),
        address1: recipientData.address1?.trim(),
        address2: recipientData.address2?.trim() || '',
        locationType,
        organizationName,
        nameOfLocation: recipientData.nameOfLocation?.trim() || '',
        state,
        country,
        zipCode: getFormattedZipCode(recipientData.zipCode),
        phoneNumber: phone ? removeMaskForPhoneNumber(phone) : '',
        city: recipientData.city?.trim(),
        email: recipientData.email?.trim() || null,
        skipAddressBookAdd: isDigitalProduct,
        relationship: recipientData.relationship || null,
    };
    if (recipientData.occasionId) {
        addressData.occasions = [
            {
                occasionCode: recipientData.occasionId,
                occasionName: recipientData.occasionName,
                occasionType: recipientData.occasionType,
                occasionMonth: recipientData.occasionMonth || null,
                occasionDay: recipientData.occasionDay || null,
                occasionYear: recipientData.occasionYear || null,
                remindMe: recipientData.remindMe,
            },
        ];

        if (recipientData.extraOccasionDay && recipientData.extraOccasionMonth) {
            addressData.occasions.push({
                occasionCode: '3',
                occasionName: 'Birthday',
                occasionType: 'Event',
                occasionMonth: recipientData.extraOccasionMonth || null,
                occasionDay: recipientData.extraOccasionDay || null,
                occasionYear: recipientData.extraOccasionYear || null,
            });
        }
    }
    // Split the name and last name from full name input before send the data
    if (recipientData.firstAndLastName) {
        const firstAndLastNameValue = (recipientData.firstAndLastName).trim();
        const listWords = firstAndLastNameValue?.split(' ') || [];
        addressData.firstName = recipientData.firstAndLastName;
        addressData.lastName = '';

        if (listWords.length > 1) {
            addressData.firstName = '';
            const totalWordsFirstName = Math.ceil(listWords.length / 2);
            addressData.firstName = listWords.slice(0, totalWordsFirstName).join(' ')?.trim();
            addressData.lastName = listWords.slice(totalWordsFirstName).join(' ')?.trim();
        }
    }
    return addressData;
};

const maskPhoneNumber = (phone) => {
    const V1 = /^\((\d\d\d)\)\s$/; // the phone come with (201), dont need continue the process
    const V2 = /^\((\d\d\d)\)\s(\d\d\d)-$/; // the phone come with (201) 235-, dont need continue the process
    // start transform the code
    if (V1.test(phone)) {
        return {
            maskInputVal: String(phone).replace(V1, '$1'),
            allow: true,
        };
    }
    if (V2.test(phone)) {
        return {
            maskInputVal: String(phone).replace(V2, '($1) $2'),
            allow: true,
        };
    }

    let phoneNumber = String(phone).replace(/[^0-9]+/g, '');

    if (phoneNumber.length > 10) {
        // International numbers
        phoneNumber = phoneNumber.replace(/^(\d\d)(\d{3})(\d{3})(\d{0,4}).*/, '$1 $2 $3 $4');
    } else if (phoneNumber.length > 5) {
        // big to 5 digit do the form is it is not already there 201123435 -> (201) 123-435
        phoneNumber = phoneNumber.replace(/^(\d\d\d)(\d{3})(\d{0,4}).*/, '($1) $2-$3');
    } else if (phoneNumber.length > 3) {
        // bit to 3 digit do the form is it is not already there 20123 -> (201) 23
        phoneNumber = phoneNumber.replace(/^(\d\d\d)(\d{0,4})/, '($1) $2');
    } else {
        // bit to 1 digit do the form is it is not already there 201 -> (201)
        phoneNumber = phoneNumber.replace(/^(\d*)/, '$1');
    }

    return phoneNumber;
};

const defaultInputs = [
    'firstName', 'lastName', 'address1', 'address2',
    'locationType', 'organizationName', 'zipCode', 'state',
    'city', 'country', 'phone', 'phoneNumber', 'email', 'personalizationLines',
];

export const getNonFieldErrors = (listToFilter, keyList) => {
    let keysToCompare = keyList;

    if (!keysToCompare || keysToCompare.length <= 0) {
        keysToCompare = defaultInputs;
    }

    if (keysToCompare?.length && listToFilter) {
        return listToFilter.filter((erroKey) => !keysToCompare.includes(erroKey));
    }
    return [];
};

export const getOnlyInputFieldErrors = (listToFilter, keyList) => {
    let keysToCompare = keyList;

    if (!keysToCompare || keysToCompare.length <= 0) {
        keysToCompare = defaultInputs;
    }

    if (keysToCompare?.length && listToFilter) {
        return listToFilter.filter((erroKey) => keysToCompare.includes(erroKey));
    }
    return [];
};

export const getAddressOneLineString = (address, type, html = false, isSummary = false) => {
    const phoneNumber = address.phoneNo?.trim() || address.phoneNumber?.trim() || address.phone?.trim() || '';
    let country = address.country || 'USA';
    if (isSummary && country?.length === 3) {
        const countryObj = getCountryDetailsByThreeDigitCountryCode(country);
        country = countryObj.countryCodeTwoDigit;
    } else if (country?.length !== 3) {
        country = getCountryCodeFromTwoToThreeDigit(country);
    }

    let buildAddress = `${address.firstName?.trim()} ${address.lastName?.trim()}, ${address.organizationName ? `${address.organizationName.trim()}, ` : ''}${address.address1?.trim()}, ${address.address2?.trim() ? `${address.address2?.trim()}, ` : ''}${address.city?.trim()}, ${address.state?.trim()}, ${country}, ${address.zipCode?.trim()}${html ? `, <span>${maskPhoneNumber(phoneNumber)}</span>` : `, ${maskPhoneNumber(phoneNumber)}`}`;

    if (type === 'addressLine') {
        buildAddress = `${address.firstName?.trim()} ${address.lastName?.trim()}, ${address.organizationName ? `${address.organizationName.trim()}, ` : ''}${address.address1 ? `${address.address1?.trim()}, ` : ''}${address.address2?.trim() ? `${address.address2?.trim()}, ` : ''}${address.city?.trim()}, ${address.state}, ${address.country ? `${country}, ` : ''}${address.zipCode !== '00000' ? `${address.zipCode?.trim()}, ` : ''} ${html ? `<span>${maskPhoneNumber(phoneNumber)}</span>` : `, ${maskPhoneNumber(phoneNumber)}`}`;
    }

    if (type === 'digitalAddressLine') {
        buildAddress = `${address.firstName?.trim()} ${address.lastName?.trim()}, ${address.email?.trim()}`;
    }
    if (type === 'addressBookEntry') {
        buildAddress = `${address.firstName?.trim()} ${address.lastName?.trim()}, ${address.employerName ? `${address.employerName.trim()},` : ''} ${address.addressLineOne ? `${address.addressLineOne.trim()},` : ''} ${address.addressLineTwo ? `${address.addressLineTwo?.trim()},` : ''} ${address.city?.trim()} ${address.state?.trim()} ${address.country?.trim()}, ${address.zip?.trim()}, ${html ? `<span>${maskPhoneNumber(phoneNumber)}</span>` : maskPhoneNumber(phoneNumber)}`;
    }
    buildAddress = buildAddress.replace(/ ,/g, ',');

    return buildAddress.trim();
};

export const getMobileBreakAddress = (address, type) => {
    const phoneNumber = address.phoneNo?.trim() || address.phoneNumber?.trim() || address.phone?.trim() || '';
    let country = address.country || 'US';
    if (country?.length === 3) {
        const countryObj = getCountryDetailsByThreeDigitCountryCode(country);
        country = countryObj.countryCodeTwoDigit;
    }

    let buildAddress = `${address.firstName?.trim()} ${address.lastName?.trim()}<br/>${address.organizationName ? `${address.organizationName.trim()},<br/>` : ''}${address.address1?.trim()}${address.address2 ? `, ${address.address2?.trim()}` : ''}<br/>${address.city?.trim()}, ${address.state?.trim()} ${country}, ${address.zipCode?.trim()}<br/>${maskPhoneNumber(phoneNumber)}`;

    if (type === 'addressLine') {
        buildAddress = `${address.firstName?.trim()} ${address.lastName?.trim()}<br/>${address.organizationName ? `${address.organizationName.trim()},<br/>` : ''}${address.address1?.trim()}${address.address2 ? `, ${address.address2?.trim()}` : ''}<br/>${address.city?.trim()}, ${address.zipCode !== '00000' ? `${address.state?.trim()}, ` : ''}${country}, ${address.zipCode !== '00000' ? `${address.zipCode?.trim()}<br/>` : ''}${maskPhoneNumber(phoneNumber)}`;
    }

    if (type === 'digitalAddressLine') {
        buildAddress = `${address.firstName?.trim()} ${address.lastName?.trim()}, ${address.email?.trim()}`;
    }
    return buildAddress;
};

export const getListGuestAddresses = (addressEntries, lineItemType, productBrandId) => {
    const guestAddressObjectArray = [];
    addressEntries.forEach((location, index) => {
        if ((lineItemType === 'GREETINGCARD-ITEM' || productBrandId === '1036') && ['Residence', 'Business'].includes(location.locationType)) {
            guestAddressObjectArray.push({
                key: index,
                value: getAddressOneLineString(location),
            });
        } else if (lineItemType !== 'GREETINGCARD-ITEM' || productBrandId !== '1036') {
            guestAddressObjectArray.push({
                key: index,
                value: getAddressOneLineString(location),
            });
        }
    });

    return [
        {
            key: 'default',
            value: 'No address selected',
        },
        ...guestAddressObjectArray,
    ];
};

export const getListCreditCardWallet = (listWallet) => {
    const creditCardsWalletArray = listWallet.map((card) => ({
        key: card.walletId,
        value: `${card.cardHolderName || ''} - ${card.cardType} ending in ${card.lastFourDigits || ''} - Exp. ${card.expiryDate}`,
    }));

    if (creditCardsWalletArray.length > 0) {
        return [
            {
                key: 'default',
                value: 'Select Credit Card',
            },
            ...creditCardsWalletArray,
            {
                key: 'new',
                value: '+ Add New Credit Card',
            },
        ];
    }
    return null;
};

export async function getListCityByZipcode(zipCodeValue, currentFormCity) {
    let responseCityStateFromZip = {
        cityArray: {},
    };

    let formZipCode = zipCodeValue;
    let labelZip = 'Zip Code';
    let checkZip = false;

    if ((formZipCode.length === 6 || formZipCode.length === 7) && isCandaZip(formZipCode)) {
        checkZip = true;
        const zipSplit = formZipCode.replace(/\s/gi, '').toUpperCase().split('');
        zipSplit.splice(3, 0, ' ');
        formZipCode = zipSplit.join('');
        labelZip = 'Postal Code';
    } else if (formZipCode.length >= 5) { // This is important for checkout, zipcode from the API returns without the zipcode extension (60015-5253) -  60015 is used for saving the zipcode
        checkZip = true;
    }

    if (zipCodeValue && checkZip) {
        const jwtToken = await getAccessTokenSafely();

        responseCityStateFromZip = await orderClient.getCityStateFromZip({}, jwtToken, formZipCode)
            .then((resStateCityData) => {
                const cityStateDate = resStateCityData?.data?.esbSaltaServiceResponse || {};

                if (cityStateDate && cityStateDate.checkZipResponse
                    && cityStateDate.checkZipResponse.checkZipResult
                    && cityStateDate.checkZipResponse.checkZipResult
                ) {
                    if (cityStateDate.checkZipResponse.checkZipResult.flwsErrors) {
                        throw new Error(`${'Invalid '}${labelZip}`);
                    } else if (
                        cityStateDate.checkZipResponse.checkZipResult.location
                        && cityStateDate.checkZipResponse.checkZipResult.location.state
                    ) {
                        const {
                            checkZipResponse: {
                                checkZipResult: {
                                    location: {
                                        state,
                                        country,
                                        cityList: {
                                            city,
                                        },
                                        zipCode,
                                    },
                                },
                            },
                        } = cityStateDate;

                        const cityList = [
                            ...new Set(city),
                        ];

                        const cityFromList = getCity(cityList, currentFormCity);

                        if (country === 'CAN' || country === 'USA') {
                            return {
                                country,
                                state,
                                cityArray: cityList,
                                city: cityFromList,
                                zipCode,
                            };
                        }

                        return {
                            state,
                            cityArray: cityList,
                            city: cityFromList,
                            zipCode,
                        };
                    }
                }

                return {
                    cityArray: {},
                };
            });
    }

    return responseCityStateFromZip;
}

export const triggerStateCityData = async (
    zipCode, city, formFieldValues, setFormFieldValues, validateFormFields,
    orderItemError, orderItem, callSetOrderItemError, featureFlags,
    countriesProductDeliverable,
    isBillingForm, actionPrefillFormAddress, cartId,
    callClearOrderItemErrors,
) => {
    try {
        if (zipCode?.length >= 5) {
            const sanitizeZipcode = zipCode.split('-')[0] || zipCode;
            const country = formFieldValues.country;
            const isUSA = ['US', 'USA'].includes(country);
            const isCAN = ['CA', 'CAN'].includes(country);

            const regUSA = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
            const regCAN = /(^[A-Z|a-z]\d[A-Z|a-z] \d[A-Z|a-z]\d$)|(^[A-Z|a-z]\d[A-Z|a-z]\d[A-Z|a-z]\d$)/;

            const isValidUSAZipCode = regUSA.test(zipCode);
            const isValidCANZipCode = regCAN.test(zipCode);

            if (
                ((isUSA || isCAN) && zipCode.indexOf('00000') < 0)
                && (
                    (isUSA && !isValidCANZipCode && (isValidUSAZipCode || zipCode?.replace(' ', '')?.length >= 5))
                    || (isCAN && !isValidUSAZipCode && (isValidCANZipCode || zipCode?.replace(' ', '')?.length >= 6))
                    || (isValidCANZipCode && (isBillingForm || countriesProductDeliverable.includes('CAN')))
                    || (isValidUSAZipCode && (isBillingForm || countriesProductDeliverable.includes('USA')))
                )
            ) {
                const resListCityByZipcode = await getListCityByZipcode(sanitizeZipcode, city);
                if (resListCityByZipcode.cityArray?.length > 0) {
                    const updateFormFieldValues = {
                        country,
                    };
                    const fieldsToValidate = ['city', 'state', 'zipCode'];

                    if (zipCode !== updateFormFieldValues.zipCode) {
                        updateFormFieldValues.zipCode = zipCode;
                        if ((zipCode.length === 6 || zipCode.length === 7) && isCandaZip(zipCode)) {
                            const zipSplit = zipCode.replace(/\s/gi, '').toUpperCase().split('');
                            zipSplit.splice(3, 0, ' ');
                            updateFormFieldValues.zipCode = zipSplit.join('');
                        }
                    }

                    if (resListCityByZipcode.city && city && !resListCityByZipcode.cityArray.includes(city.toUpperCase())) {
                        updateFormFieldValues.city = resListCityByZipcode.city;
                    } else if (resListCityByZipcode.city && !city) {
                        updateFormFieldValues.city = resListCityByZipcode.city;
                    }
                    if (resListCityByZipcode.state && resListCityByZipcode.state !== formFieldValues.state) {
                        updateFormFieldValues.state = resListCityByZipcode.state;
                    }

                    if (resListCityByZipcode.country && resListCityByZipcode.country !== formFieldValues.country && (isBillingForm || countriesProductDeliverable.includes(resListCityByZipcode.country))) {
                        updateFormFieldValues.country = resListCityByZipcode.country;
                        fieldsToValidate.push('country');
                    }

                    if (isBillingForm) {
                        await actionPrefillFormAddress(updateFormFieldValues);
                        if (callClearOrderItemErrors) {
                            callClearOrderItemErrors(
                                cartId,
                                'payment',
                                {
                                    errType: 'clearAllFields',
                                    field: '',
                                },
                            );
                        }
                    } else {
                        setFormFieldValues((prevState) => ({
                            ...prevState,
                            ...updateFormFieldValues,
                        }));
                    }

                    if (
                        !isBillingForm
                        || (['US', 'USA'].includes(updateFormFieldValues.country) && (zipCode.length === 5 || zipCode.length === 10))
                        || (['CA', 'CAN'].includes(updateFormFieldValues.country) && zipCode.length > 5)
                    ) {
                        validateFormFields(fieldsToValidate, updateFormFieldValues, false);
                    }
                }
            } else if (zipCode) {
                const fieldsToValidate = ['zipCode'];
                if (isBillingForm) {
                    actionPrefillFormAddress({
                        city: '',
                        state: '',
                    });
                } else if (formFieldValues.city || formFieldValues.state) {
                    setFormFieldValues((prevState) => ({
                        ...prevState,
                        city: '',
                        state: '',
                    }));
                }

                validateFormFields(fieldsToValidate, { zipCode, country }, false);
            }
        }
    } catch (er) {
        if (
            ['Invalid Postal Code', 'Invalid Zip Code'].includes(er.message)
            && (
                (orderItem.cartItemId && orderItemError?.[orderItem.cartItemId]?.recipient?.validationErrors?.zipCode !== er.message)
                || (isBillingForm && orderItemError?.[cartId]?.payment?.validationErrors?.zipCode !== er.message)
            )
        ) {
            let errorMessage = er.message;
            if (formFieldValues.country === 'CAN' && er.message === 'Invalid Zip Code') {
                errorMessage = 'Invalid Postal Code';
            }

            if (
                (['CAN', 'CA'].includes(formFieldValues.country) && zipCode.length > 5)
                || (['USA', 'US'].includes(formFieldValues.country) && (zipCode.length === 5 || zipCode.length === 10))
            ) {
                if (isBillingForm) {
                    callSetOrderItemError(
                        cartId,
                        {
                            payment: {
                                errorKey: 'ZIPCODE_VALIDATION_ERROR',
                                validationErrors: {
                                    zipCode: errorMessage,
                                },
                            },
                        },
                    );

                    actionPrefillFormAddress({
                        city: '',
                        state: '',
                    });
                } else {
                    callSetOrderItemError(
                        orderItem.cartItemId,
                        {
                            recipient: {
                                errorKey: 'ZIPCODE_VALIDATION_ERROR',
                                validationErrors: {
                                    zipCode: errorMessage,
                                },
                            },
                        },
                    );

                    setFormFieldValues((prevState) => ({
                        ...prevState,
                        city: '',
                        state: '',
                    }));
                }
            }
        }

        if (featureFlags['is-checkout-monitoring-enabled']) {
            console.error({
                appName: process.env.npm_package_name,
                module: 'Input-Helper.js',
                function: 'triggerStateCityData',
                jsError: er,
                message: `Error triggerStateCityData in Address Book API call failed getting the zipcode ${zipCode}`,
            });
        }
    }
};

export async function getDateAndTimeByZipcode(zipCodeValue) {
    let resultDateAndTime = null;

    const formZipCode = zipCodeValue;
    let checkZip = false;

    if (!isCandaZip(formZipCode) && formZipCode.length >= 5) { // This is important for checkout, zipcode from the API returns without the zipcode extension (60015-5253) -  60015 is used for saving the zipcode
        checkZip = true;
    }

    if (zipCodeValue && checkZip) {
        const jwtToken = await getAccessTokenSafely();
        resultDateAndTime = await orderClient.getCityStateFromZip({}, jwtToken, formZipCode)
            .then((resStateCityData) => {
                const response = resStateCityData?.data?.esbSaltaServiceResponse || {};

                if (
                    response?.checkZipResponse?.checkZipResult?.location?.timeZone
                    && response?.checkZipResponse?.checkZipResult?.location?.country === 'USA'
                ) {
                    const timeZone = response.checkZipResponse.checkZipResult.location.timeZone;
                    let derivedTimeZone = null;

                    switch (timeZone) {
                        case 'AST':
                            derivedTimeZone = 'America/Anguilla';
                            break;
                        case 'EST':
                            derivedTimeZone = 'America/New_York';
                            break;
                        case 'CST':
                            derivedTimeZone = 'America/Chicago';
                            break;
                        case 'MST':
                            derivedTimeZone = 'US/Mountain';
                            break;
                        case 'PST':
                            derivedTimeZone = 'America/Los_Angeles';
                            break;
                        case 'AKST':
                            derivedTimeZone = 'US/Alaska';
                            break;
                        case 'HST':
                            derivedTimeZone = 'US/Hawaii';
                            break;
                        default:
                            derivedTimeZone = null;
                    }

                    if (derivedTimeZone) {
                        const dateTimeZone = new Date(new Date().toLocaleString('en-US', { timeZone: derivedTimeZone }));
                        return {
                            dateTimeZone,
                            timeZone: derivedTimeZone,
                        };
                    }
                }

                return null;
            });
    }

    return resultDateAndTime;
}

export async function getProductCardIsleAvailability({
    zipCode, locationType, orderItem, greetingCardSku, orderId, cgcEnabled,
}) {
    const defaultCardIsleResponse = {
        available: false,
        productCode: '',
        productPrice: 0,
    };

    try {
        if (
            (orderItem && zipCode && locationType && orderItem?.deliveryInfo?.deliveryDate)
            || !cgcEnabled
        ) {
            const { product } = orderItem;
            const brandCode = product.brandCode || '';

            let productCode = product.productCode || '';
            if (productCode?.indexOf('-') >= 0) {
                productCode = productCode.split('-');
                productCode = productCode[productCode.length - 1];
            }

            const jwtToken = await getAccessTokenSafely();
            const payload = {
                jwtToken,
                productCode,
                brandCode,
                locationType,
            };

            const currentDate = orderItem?.deliveryInfo?.deliveryDate ? new Date(orderItem.deliveryInfo.deliveryDate) : null;
            let deliveryDate = null;

            // Food brands skip zipcode and the delivery date when call for availability
            if (currentDate && !cgcEnabled) {
                const currentDay = (`0${currentDate.getDate()}`).slice(-2);
                const currentMonth = (`0${currentDate.getMonth() + 1}`).slice(-2);
                deliveryDate = currentDate ? `${currentMonth}/${currentDay}/${currentDate.getFullYear()}` : null;

                // Flex forced date is different from the delivery date, use the forced date
                if (orderItem?.selectedFlexOption?.forcedDelDate) {
                    const forcedDelDate = getFormattedDate(orderItem.selectedFlexOption.forcedDelDate, 'MM/dd/yyyy');

                    if (forcedDelDate !== deliveryDate) {
                        deliveryDate = forcedDelDate;
                    }
                }

                payload.zipCode = zipCode;
                payload.deliveryDate = deliveryDate;
            }

            if (greetingCardSku && greetingCardSku !== '') payload.greetingCardSku = greetingCardSku;

            const responseCI = await orderClient.getGreetingAvailability(payload);
            if (responseCI?.data && responseCI.data?.available) {
                if (responseCI.data.productCode) {
                    const payloadPriceEngine = {
                        jwtToken,
                        products: [{ partNumber: `${brandCode}-${responseCI.data.productCode}` }],
                        variants: [],
                    };

                    const priceRulesResponse = await getPriceFromEngine({}, jwtToken, payloadPriceEngine, false);

                    if (priceRulesResponse?.data?.products?.[0]?.prices && priceRulesResponse.data.products[0].priceRules.length > 0) {
                        const productPriceData = priceRulesResponse.data.products[0].prices.find((price) => price.type === 'sale');
                        responseCI.data.priceRules = priceRulesResponse.data.products[0].priceRules;
                        responseCI.data.productPrice = productPriceData.value;
                    }
                }

                return responseCI.data;
            }
            return defaultCardIsleResponse;
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            function: 'getProductCardIsleAvailability',
            component: 'Input-Helper',
            jsError: ex,
            message: `Error getProductCardIsleAvailability API call failed getting the card Isle Availability ${zipCode} ${orderId}`,
        });
        return defaultCardIsleResponse;
    }
    return defaultCardIsleResponse;
}

export const isValidUSZipCode = (zipcode) => {
    if (/^\d{5}$|^\d{9}$|^\d{5}-\d{4}$/.test(zipcode)) {
        return true;
    }
    return false;
};

export const isUsaOrCanada = (currentCountry) => {
    const country = currentCountry ? currentCountry.substring(0, 2) : 'US';
    return ['US', 'CA'].includes(country);
};

export const getFieldsToValidateRecipient = (recipientData, recipientFieldState, isDigitalProduct) => {
    let locationType = recipientData.locationType;
    if (locationType === 'P.O.Box') {
        locationType = 'POBox';
    } else if (locationType === 'APO/FPO') {
        locationType = 'APOFPO';
    }

    if (
        isDigitalProduct
        && (
            !recipientData
            || !recipientData.firstName
            || !recipientData.lastName
            || !recipientData.email
            || recipientFieldState.email.flagError
        )
    ) {
        return [
            'firstName', 'lastName', 'email', 'phone', 'address1',
            'zipCode', 'state', 'city', 'occasionMonth', 'occasionDay',
            'extraOccasionMonth', 'extraOccasionDay',
        ];
    }

    if (
        !recipientData.firstName || !recipientData.lastName
        || (
            !isDigitalProduct
            && (
                !recipientData
                || !recipientData.address1 || !recipientData.zipCode || !recipientData.city
                || !recipientData.state || !recipientData.country
                || recipientFieldState.zipCode.errorMessage
                || (locationType === 'APOFPO' && !recipientData.address2)
                || (!['Residence', 'Apartment', 'APOFPO', 'POBox'].includes(locationType) && !recipientData.organizationName)
                || (recipientFieldState.phone.required && (!recipientData.phoneNumber || recipientData.phoneNumber.length < 10))
                || (recipientFieldState.occasionDay.required && !recipientData.occasions?.[0]?.occasionDay)
                || (recipientFieldState.occasionMonth.required && !recipientData.occasions?.[0]?.occasionMonth)
                || (recipientFieldState.extraOccasionDay.required && !recipientData.occasions?.[1]?.occasionDay)
                || (recipientFieldState.extraOccasionMonth.required && !recipientData.occasions?.[1]?.occasionMonth)
            )
        )
    ) {
        const fieldsToValidate = [
            'firstName', 'lastName', 'address1', 'address2', 'phone',
            'city', 'state', 'country', 'zipCode', 'organizationName',
            'occasionMonth', 'occasionDay', 'extraOccasionMonth', 'extraOccasionDay',
        ];
        if (recipientFieldState?.phone?.required) {
            fieldsToValidate.push('phone');
        }

        return fieldsToValidate;
    }

    return [];
};

export const getFieldsToValidateGiftMessage = (giftMessageData) => {
    const formFieldState = giftMessageData.state;
    const formData = giftMessageData.data;

    if (
        giftMessageData.type === 'giftMessage'
        && formFieldState.signature.required
        && (
            (formData.message && !formData.signature)
            || (!formData.message && formData.signature)
        )
    ) {
        return ['message', 'signature'];
    }
    return [];
};

export const getAddressForExternalCart = (recipientAddress) => {
    let address = recipientAddress.address1;

    if (recipientAddress.address2?.trim()) {
        address += `, ${recipientAddress.address2.trim()}`;
    }

    const zipCode = recipientAddress.zipCode?.split('-')?.[0] || recipientAddress.zipCode;

    address += `, ${recipientAddress.city}, ${recipientAddress.state} ${recipientAddress.country}, ${zipCode}`;

    return address;
};

export const getOccasionList = (occasionList) => {
    const listData = {};
    const listDropdown = [{
        key: '',
        value: 'Please select an occasion',
    }];
    const listOccasionCodeEvents = [];

    if (occasionList?.length > 0) {
        occasionList.forEach((item) => {
            listDropdown.push({
                key: item.code,
                value: item.name,
            });

            listData[item.code] = {
                code: item.code,
                name: item.name,
                type: item.type || 'Holiday',
                remindMe: item.remindMe,
            };

            if (Number(item.code)) {
                listOccasionCodeEvents.push(item.code);
            }
        });
    }

    return {
        listDropdown,
        listData,
        listOccasionCodeEvents,
    };
};

export const getMonthsDropdown = () => {
    const monthList = [{ key: '', value: 'MM' }];
    for (let i = 1; i <= 12; i += 1) {
        const monthText = i < 10 ? `0${i}` : i;
        monthList.push({
            key: monthText,
            value: monthText,
        });
    }
    return monthList;
};

export const getDaysDropdown = () => {
    const daysList = [{ key: '', value: 'DD' }];
    for (let i = 1; i <= 31; i += 1) {
        const dayText = i < 10 ? `0${i}` : i;
        daysList.push({
            key: dayText,
            value: dayText,
        });
    }
    return daysList;
};

export const getYearsDropdown = () => {
    const daysList = [{ key: '', value: 'YYYY' }];
    for (let i = 1901; i <= new Date().getFullYear(); i += 1) {
        const dayText = i < 10 ? `0${i}` : i;
        daysList.push({
            key: dayText,
            value: dayText,
        });
    }
    return daysList;
};

export const getListRelationShipDropdown = (relationShipList) => {
    const relationshipMapped = [{
        key: '',
        value: 'Select a Relationship',
    }];

    if (Object.keys(relationShipList)?.length > 0) {
        Object.keys(relationShipList).forEach((relationKey) => {
            relationshipMapped.push({
                key: relationKey,
                value: relationShipList[relationKey],
            });
        });
    }

    return relationshipMapped;
};

export const convertHTMLtoText = (html) => {
    const bodyHTML = document.implementation.createHTMLDocument('New').body;
    bodyHTML.innerHTML = html;
    return bodyHTML.textContent || bodyHTML.innerText || '';
};

export const recipientBuilder = (address) => {
    const profile = address;
    const buildAddress = {};

    if (profile.addressBookEntryId) {
        buildAddress.addressId = profile.addressBookEntryId;
    }

    let locationType = profile.addressType || 'Residence';
    if (locationType === 'P.O.Box' || locationType === 'P.O. Box') {
        locationType = 'POBox';
    } else if (locationType === 'APO/FPO') {
        locationType = 'APOFPO';
    }

    let country = profile.country || 'USA';
    if (country === 'CA') {
        country = 'CAN';
    } else if (country === 'US') {
        country = 'USA';
    }

    buildAddress.locationType = profile.addressType ? profile.addressType : 'Residence';

    buildAddress.entryId = profile.addressBookEntryId;
    buildAddress.rcpId = profile.rcpId;
    buildAddress.firstName = profile.firstName || '';
    buildAddress.lastName = profile.lastName || '';
    buildAddress.relationship = profile.relationship || '';
    buildAddress.address1 = profile.addressLineOne || '';
    buildAddress.address2 = profile.addressLineTwo?.substring(0, 30) || '';
    buildAddress.city = profile.city || '';
    buildAddress.state = profile.state || '';
    buildAddress.country = country;
    buildAddress.zipCode = profile.zip || '';
    buildAddress.locationType = locationType;
    buildAddress.organizationName = profile.employerName || '';
    buildAddress.phone = profile.phoneNumber || profile.phone || '';
    buildAddress.email = profile.email || '';
    buildAddress.isAddressVerified = 'U';
    buildAddress.dpvIndicator = 'Y';

    return buildAddress;
};
